import React from 'react';
import { Chip } from '@mui/material';

const CONFIG = {
  draft:     { label: 'ร่าง',       color: 'default' },
  sent:      { label: 'ส่งแล้ว',    color: 'info'    },
  approved:  { label: 'อนุมัติ',    color: 'success' },
  rejected:  { label: 'ปฏิเสธ',    color: 'error'   },
  cancelled: { label: 'ยกเลิก',    color: 'warning' },
};

export default function StatusBadge({ status, size = 'small' }) {
  const cfg = CONFIG[status] || { label: status, color: 'default' };
  return <Chip label={cfg.label} color={cfg.color} size={size} sx={{ fontWeight: 600 }} />;
}
